import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MinaTradarService } from './mina-tradar.service';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { Subscription } from 'rxjs';
import { Trad } from '../../interfaces/trad.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../session/session.service';
@Component({
    selector: 'app-mina-tradar',
    templateUrl: './mina-tradar.component.html',
    styleUrls: ['./mina-tradar.component.scss'],
    animations: [
        fadeInAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MinaTradarComponent {
  constructor(
    protected service: MinaTradarService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router) {
    this.applyFilter();
  }

  public get isLoaded() { return !!this.minaTradar };

  public ngOnInit() {
    this.loadMinaTradar();
  }

  public ngOnDestroy(): void {
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public userFilter: any;

  public readonly tradTypes = [
    { namn: 'Begäran om attestering', typ: 'attest' },
    { namn: 'Begäran om signering', typ: 'sign' },
    { namn: 'Övriga meddelanden', typ: 'msg' },
    { namn: 'Ändring av personuppgifter', typ: 'pers' }
  ];

  public applyFilter() {
    this.userFilter = {
      $or: [
        {
          arende:
          {
            galdenar: { namn: this.filterText }
          }
        },
        {
          skapadAvNamn: this.filterText
        },
        {
          amne: this.filterText
        },
        {
          status: { namn: this.filterText }
        }
      ]
    }
  }

  public patchFilter(tradType: string) {
    const patchedFilter = Object.assign({}, this.userFilter, { tradTyp: { typ: tradType } }); //{ $or: this.userFilter.$or, tradTyp: { typ: tradType } };
    return patchedFilter;
  }

  public filterText: string;
  public order: string = 'status.namn';
  public reverse: boolean = false;
  public previousArendeId: string;

  public subscription: Subscription;

  public minaTradar: Trad[];

  private getTime(dateString: string) {
    return dateString != null ? new Date(dateString).getTime() : 0;
  }

  private loadMinaTradar() {

    const doLoad = () => {
      setTimeout(() => {
          if (!this.minaTradar) {
            this.spinner.show();
          }
        },
        300);

      this.service.getMinaTradar(this.sessionService.activeInstance.id).subscribe(
        result => {
          this.spinner.hide();
          this.minaTradar = result.sort((t1: Trad, t2: Trad) => this.getTime(t2.datumSkapad) - this.getTime(t1.datumSkapad));
        });
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(doLoad);
      return;
    }

    doLoad();
  }

  public get instanceName() {
    return this.sessionService.activeInstance.name;
  }

  public setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }
}
